import generateUtilityClass from '@mui/base/generateUtilityClass';
import generateUtilityClasses from '@mui/base/generateUtilityClasses';
export function getStarRatingUtilityClass(slot) {
  return generateUtilityClass('MuiOriStarRating', slot);
}
const starRatingClasses = generateUtilityClasses('MuiOriStarRating', ['root', 'star', 'textRating', 'emptyStar', 'fullStar', 'halfStar']);
export default starRatingClasses;